<script>
  // Dependencies
  import { User } from '@coldandgoji/svelte-authentication'
  import { composeClasses, publish, subscribe } from '@coldandgoji/utilities'
  import { initialize } from '@core/initialize.js'
  import { onMount } from 'svelte'
  import { routes } from '@core/routes.js'

  // Components
  import { Debug } from '@coldandgoji/svelte-debug'
  import { Loader } from '@coldandgoji/svelte-ui'
  import { Router } from '@coldandgoji/svelte-router'

  let initialized = false

  onMount( async () => {
    // Display loader
    publish( 'Loader.add.message', { message: 'Initializing...' } )

    // Initialize Application
    await initialize()

    initialized = true

    publish( 'Loader.dismiss' )

    subscribe( 'User.logged.in', async () => {
      console.log( 'User.logged.in' )
      await initialize()
      publish( 'Router.navigate' )
    } )

    subscribe( 'User.logged.out', async () => {
      console.log( 'User.logged.out' )
      publish( 'Router.navigate' )
    } )
  } )

  $: classes = composeClasses( [
    'Application',
  ] )
</script>

<div class={ classes }>
  <Router { routes } { initialized } />
</div>

<style global>
  @import './Application.css';
</style>
